import { logNewRelicPageAction } from '@makemydeal/dr-activities-common';
import { dealerSelectors, featureToggleSelectors } from '@makemydeal/dr-shared-store';

import { SOCKET_EVENT_IGNORED } from '../../actionTypes/socketActionTypes';
import { contractingEventReceived } from '../contractingActionCreators';
import * as offerSelectors from '../../selectors/offerSelectors';
import { createSocketLoggingContext } from './loggingContext';
import type { TopicHandler } from './types';

export const handleDrContracting: TopicHandler = (state, event) => {
    const isDisplayContractStatusEnabled = featureToggleSelectors.isDisplayContractStatusEnabled(state);
    if (!(dealerSelectors.getEnableGenerateContracts(state) || isDisplayContractStatusEnabled)) {
        return null;
    }

    if (!event.message) {
        return contractingEventReceived(event);
    }

    // Confirm in New Relic that the contracting topic subscription was successful
    const dealRefId = offerSelectors.getDealRefId(state);
    if (event.message === 'subscribe Complete.' && dealRefId) {
        logNewRelicPageAction('MV:Contracting - WebSocket Topic Subscribed Successfully', {
            ...createSocketLoggingContext(state, event),
            subscriptionStatus: 'success',
            reason: 'subscription_complete'
        });
    }
    return { type: SOCKET_EVENT_IGNORED, payload: event };
};
